import React, { useState } from 'react'
//import ReCAPTCHA from "react-google-recaptcha";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { sendForgotPassword, updateLoginState, resetLoginState } from '../actions/loginactions'
import * as appConstants from '../../../overrides/appconstants'

export default function RecoverPassword() {
  const { register, handleSubmit, reset: resetLoginstate, watch, formState: { errors } } = useForm();
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const state = useSelector(state => state.loginReducer);

  // const [captchaCompleted, setCaptchaCompleted] = useState(false);
  // const [captchaError, setCaptchaError] = useState(false);
  // console.log(captchaCompleted)
  // console.log(captchaError)
  const onSubmit = async () => {
    // if (!captchaCompleted) {
    //   setCaptchaError(true);
    //   {
    //     // let dialogeData = {
    //     //   message: `Please complete the CAPTCHA.`,
    //     //   showConfirmPopup: true,
    //     //   isConfirm: false,
    //     //   isInfo: true,
    //     // }

    //     // await dispatch(actions.toggleConfirmPopup(dialogeData));
    //     return true;
    //   }

    // }

    let resp = await dispatch(sendForgotPassword());
    if (resp) {
      await resetLoginstate();
      await dispatch(resetLoginState());
      navigate('/recoverpasswordsuccess');
    }


  }
  const onError = async () => {
    // if (!captchaCompleted) {
    //   setCaptchaError(true);
    //   return false;
    // }
  }
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    dispatch(updateLoginState({ name, value }));
  }
  //   {
  //     navigate('/recoverpasswordsuccess');
  // }
  const handleCaptchaChange = (value) => {
    // if (value) {
    //   setCaptchaCompleted(true);
    //   setCaptchaError(false);
    // } else {
    //   setCaptchaCompleted(false);
    //   setCaptchaError(true);
    //   {
    //     let dialogeData = {
    //       message: `Please complete the CAPTCHA.`,
    //       showConfirmPopup: true,
    //       isConfirm: false,
    //       isInfo: true,
    //     }

    //     // dispatch(actions.toggleConfirmPopup(dialogeData));
    //     return true;
    //   }
    // }
  };
  return (
    <div className="auth-fluid">
      <div className="auth-fluid-form-box">
        <div className="align-items-center d-flex h-100">
          <div className="card-body">


            <div className="auth-brand text-center text-lg-start">
              <a href="index.html" classNameName="logo-dark">
                <span><img src="content/theme/assets/images/asniclogo.png" alt="" style={{ "height": 50 }} /></span>
              </a>
            </div>

            <h4 className="mt-0">Reset Password</h4>
            <p className="text-muted mb-4">Enter your email address and we'll send you an email with instructions to reset your password.</p>


            <form onSubmit={handleSubmit(onSubmit, onError)}>
              <div className="mb-3">
                <label for="userNametoReset" className="form-label"><span style={{ color: "red" }}>*</span> User Name</label>
                <input className={errors.userNametoReset ? 'form-control is-invalid' : 'form-control'} type="text" id="userNametoReset"
                  placeholder="Enter your UserName"
                  name='userNametoReset'
                  value={state.userNametoReset}
                  {...register("userNametoReset", { required: true, onChange: (e) => handleInputChange(e) })} />
                {errors.userNametoReset && <span style={{ color: "red" }}> User Name is Required.</span>}
                <div className="d-grid mb-0 text-center">
                  <span style={{ color: "red" }}>  </span>
                </div>
              </div>
              <div className="mb-3">
                <label for="emailaddress" className="form-label"><span style={{ color: "red" }}>*</span> Email address</label>
                <input className={errors.resetEmail ? 'form-control is-invalid' : 'form-control'} type="email" id="resetEmail"
                  placeholder="Enter your email"
                  name='resetEmail'
                  value={state.resetEmail}
                  {...register("resetEmail", { required: true, onChange: (e) => handleInputChange(e) })} />
                {errors.resetEmail && <span style={{ color: "red" }}> Email Address is Required.</span>}
                <div className="d-grid mb-0 text-center">
                  <span style={{ color: "red" }}>  {state.forgotPasswordMessage && state.forgotPasswordMessage}</span>
                </div>
              </div>


             {/* <div className="mb-3">
                <ReCAPTCHA
                  sitekey={appConstants.CAPTCHA_SITE_KEY}
                  // sitekey={appConstants.CAPTCHA_SITE_KEY_2}
                  onChange={handleCaptchaChange}
                />
                {captchaError && <span className="redstar">Please complete the CAPTCHA.</span>}
              </div>*/}

              <div className="mb-0 text-center d-grid">
                <button className="btn btn-primary" type="submit"><i className="mdi mdi-lock-reset"></i> Reset Password </button>
              </div>
            </form>


            <footer className="footer footer-alt">
              <p className="text-muted">Back to <a onClick={() => navigate('/login')} className="text-muted ms-1"><b>Log In</b></a></p>
            </footer>

          </div>
        </div>
      </div>
    </div>
  )
}
